const CategoriesData = [
    {
        cid: 1,
        cTitle: "Armchair",
    },
    {
        cid: 2,
        cTitle: "Chair",
    },
    {
        cid: 3,
        cTitle: "Computer table",
    },
    {
        cid: 4,
        cTitle: "Sofa",
    },
    {
        cid: 5,
        cTitle: "Study table",
    },
    {
        cid: 6,
        cTitle: "Table",
    },
    {
        cid: 7,
        cTitle: "Stool",
    },

];

export default CategoriesData;